/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ImageSlot/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import ImagePlaceholder from './ImagePlaceholder/index'
import LogoImage from './LogoImage/index'
import No from './No/index'
import PatientImage from './PatientImage/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function ImageSlot({
  children,
  viewPath = "/DesignSystem/ImageViewGrid/ImageGrid/ImageSlot",
  gridRowStart,
  gridRowEnd,
  gridColumnStart,
  gridColumnEnd,
  onImageAnalyze
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let imageSlotValueData = fromData.useDataFormat({ viewPath,
context: 'image_slot',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: imageSlotValueData,
})
  return (<React.Fragment
>
<div
  data-testid="ImageSlot.Vertical"
  data-view-path={viewPath}
 style={{'--grs-1-1kiM86': gridRowStart,'--gre-2-1kiM86': gridRowEnd,'--gcs-3-1kiM86': gridColumnStart,'--gce-4-1kiM86': gridColumnEnd}}
 className={`views-block ${styles.Vertical}`}
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'ImagePlaceholder'}>
<ImagePlaceholder
  viewPath={`${viewPath}/ImagePlaceholder`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PatientImage'}>
<PatientImage
  viewPath={`${viewPath}/PatientImage`}
 onImageAnalyze={onImageAnalyze}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'LogoImage'}>
<LogoImage
  viewPath={`${viewPath}/LogoImage`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}